/**
 * Minigame art and names, hand-ported: the bot modules (`minigames/*.ts`)
 * load Firebase on import, so the data sync cannot read them.
 */
import type { Localized } from '../types.js';

/** Spot line-up (`minigames/spot.ts#LIST_MOB_LIST`). */
export const spotMonsters: { name: Localized; emoji: string }[] = [
  { name: { fr: 'Minikrone', en: 'Minikron' }, emoji: '<:Minikron:1050046135592562748>' },
  { name: { fr: 'Toukancre', en: 'Toucantankerous' }, emoji: '<:Toucantankerous:1050046186855346276>' },
  { name: { fr: 'Tiwabbit Kiafin', en: 'Tiwabbit Wosungwee' }, emoji: '<:TiwabbitWosungwee:1050046173718781953>' },
  { name: { fr: 'Smush', en: 'Smush' }, emoji: '<:Smush:1071885510441713714>' },
  { name: { fr: 'Marcassin', en: 'Young Wild Boar' }, emoji: '<:YoungWildBoar:1050046189409665124>' },
  { name: { fr: 'Feanor', en: 'Feanor' }, emoji: '<:Feanor:1050046127162003506>' },
  { name: { fr: 'Dauge', en: 'Dauge' }, emoji: '<:Dauge:1050046077212045342>' },
  { name: { fr: 'Meuch', en: 'Smush' }, emoji: '<:Smush:1050046169868423208>' },
];

/** Race larvae (`minigames/larva.ts#LARVAS`) and their racing colour. */
export const larvae: { name: Localized; emoji: string; color: string }[] = [
  { name: { fr: 'Larve Bleue', en: 'Blue Larva' }, emoji: '<:LarveBleue:961973421477093396>', color: '#4f8df5' },
  { name: { fr: 'Larve Jaune', en: 'Yellow Larva' }, emoji: '<:LarveJaune:961973421862961152>', color: '#f2c230' },
  { name: { fr: 'Larve Orange', en: 'Orange Larva' }, emoji: '<:LarveOrange:961973421628080218>', color: '#f28a2e' },
  { name: { fr: 'Larve Verte', en: 'Green Larva' }, emoji: '<:LarveVerte:961973421149925497>', color: '#4cbf5a' },
];

/** Chafer casts (`minigames/chafer.ts`): a plain chafer, and the crit one that wins. */
export const chaferEmojis = {
  plain: '<:chafer:1037708787655655474>',
  crit: '<:chafercrit:1037709900618416168>',
} as const;
